<div id="globoverviewdiv" style="margin-top: 3em;" [innerHTML]="content"></div>